import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/lab/Slider'
import colors from '../../../configuration/colors'

const styles = {
  root: {
    width: '100%',
    padding: '20px 0',
    zIndex: 10
  },
  thumb: {
    backgroundColor: colors.cobalt,
    boxShadow: 'none !important'
  },
  track: {
    backgroundColor: colors.cobalt
  },
  activated: {
    boxShadow: 'none !important'
  }
}

const TickContainer = styled.ul`
  position: absolute;
  top: 50%;
  left: 0;
  height: 4px;
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  transform: translateY(-50%);
  z-index: 0;
`

const Tick = styled.li`
  height: 6px;
  width: 2px;
  margin: 0;
  background-color: ${props => props.enabled ? colors.cobalt : colors.rock};
`

class SliderWrapper extends Component {

  state = {
    value: 0
  }

  constructor (props) {
    super(props)
    this.handleChangeBound = this.handleChange.bind(this)
    this.handleDragEndBound = this.handleDragEnd.bind(this)
  }

  static getDerivedStateFromProps (props, state) {
    if (!props.enabled) {
      return {
        value: 0
      }
    }
    return state
  }

  render () {
    const {
      enabled,
      classes
    } = this.props

    return (
      <div style={{
        position: 'relative',
        marginTop: '15px',
        zIndex: '10' }}
      >
        <Slider
          disabled={!enabled}
          className={`oe-slider ${this.state.value === 0 && !enabled ? 'disabled' : ''}`}
          value={this.state.value}
          classes={classes}
          min={0}
          max={5}
          onChange={enabled ? this.handleChangeBound : null}
          onDragEnd={enabled ? this.handleDragEndBound : null}
        />
        <TickContainer>
          <Tick enabled={enabled} />
          <Tick enabled={enabled} />
          <Tick enabled={enabled} />
          <Tick enabled={enabled} />
          <Tick enabled={enabled} />
          <Tick enabled={enabled} />
        </TickContainer>
      </div>
    )
  }

  handleChange (event, value) {
    this.setState({ value, dragging: true })
  }

  handleDragEnd () {
    const self = this
    this.setState({ dragging: false })

    setTimeout(() => {
      self.props.onMasteryValueChange(self.state.value, self.props.index)
    }, 500)
  }
}

SliderWrapper.propTypes = {
  index: PropTypes.number,
  enabled: PropTypes.bool,
  value: PropTypes.number,
  classes: PropTypes.object,
  onMasteryValueChange: PropTypes.func
}

export default withStyles(styles)(SliderWrapper)
export { SliderWrapper }
